var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2 d-flex align-items-center w-100",attrs:{"autocomplete-item-ingredient-component":""}},[_c('div',{staticClass:"w-100"},[_vm._v("\n    "+_vm._s(_vm.item.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }